import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./KindleSlides.css"

import { checkItemExists, tellMeMore } from "../script";

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faAnglesDown, faEllipsis, faPencil, faHatWizard } from '@fortawesome/free-solid-svg-icons';

export default function EditableKindleSlides(props) {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(useLocation().search);

    const [pageIndex, setPageIndex] = useState(0);
    const [showAllPages, setShowAllPages] = useState(false);
    const [showHeader, setShowHeader] = useState(false);

    const lastGuid = urlParams.get('last');
    const lastIndex = urlParams.get('index');

    // Slide data
    const [slideNumber, setslideNumber] = useState(0);
    const [displaySlides, setdisplaySlides] = useState(null);

    // Edit modal
    const [showModal, setshowModal] = useState(false);

    let mouseX = 0;

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip">
            {props}
        </Tooltip>
    );

    useEffect(() => {
        // If we are returning to the previous page, make sure to start at the correct response
        if (lastIndex && !lastGuid) {
            setPageIndex(parseInt(lastIndex));
        }

        // Parse slides
        setslideNumber(Object.keys(props.slides.data).length)

        const has_expert_responses = props.slides.expert_responses

        let temp_display_slides = []

        for (const [key, value] of Object.entries(props.slides.data)) {
            let temp_object = {}
            
            // Remove all special characters and trim spaces from both sides
            const cleanKey = key.replace(/[^a-zA-Z0-9\s]/g, '').trim();
            
            if (has_expert_responses && props.slides.expert_responses[key]) {
                temp_object["title"] = cleanKey;
                temp_object["data"] = props.slides.expert_responses[key];
                temp_object["edit"] = true;
            } else {
                temp_object["title"] = cleanKey;
                temp_object["data"] = value;
                temp_object["edit"] = false;
            }
            temp_object["key"] = key;
            temp_display_slides.push(temp_object);
        }

        setdisplaySlides(temp_display_slides)
    }, []);


    // Swipe handlers
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => goToNextPage(),
        onSwipedRight: () => goToPreviousPage(),
        onSwipedDown: () => doTellMeMore(),
        onSwipedUp: () => doNavigateBack(),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    const goToNextPage = () => {
        if (pageIndex < slideNumber - 1) {
            setPageIndex((prevIndex) => prevIndex + 1); // Move to the next page
        }
    };

    const goToPreviousPage = () => {
        if (pageIndex > 0) {
            setPageIndex((prevIndex) => prevIndex - 1); // Move to the previous page
        }
    };

    const doTellMeMore = () => {
        if (props.useExtraControls && !(lastGuid) && pageIndex > 0) {
            tellMeMoreOnClick();
        }
    }

    const doNavigateBack = () => {
        if (props.useExtraControls && lastGuid) {
            navigate(`/?item=${lastGuid}&index=${lastIndex}`, { replace: true });
            window.location.reload();
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "ArrowRight") {
            goToNextPage();
        } else if (e.key === "ArrowLeft") {
            goToPreviousPage();
        } else if (e.key === "ArrowDown") {
            doTellMeMore();
        } else if (e.key === "ArrowUp") {
            doNavigateBack();
        }
    };

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [pageIndex]);

    function handleTap() {
        if (!showAllPages) {
            let width = document.getElementById("response-slides").offsetWidth;
            if (mouseX < width / 3) {
                goToPreviousPage();
                return;
            } else if (mouseX > 2 * width / 3) {
                goToNextPage();
                return;
            }
        }
        setShowAllPages(!showAllPages);
        setShowHeader(!showHeader);
    };

    function recordMouseX(event) {
        mouseX = event.clientX;
    }

    const handlePageClick = (index) => {
        setPageIndex(index);
        setShowAllPages(false);
        setShowHeader(false);
    };


    const text_max_length = 35;
    function getShortenedHeader(text) {
        if (text.length < text_max_length) {
            return text;
        } else {
            // Not a clever way of doing this, should probably do it smartly at some point
            while (text.length > text_max_length) {
                text = text.substring(0, text.lastIndexOf(" "));
            }
            return text + "..."
        }
    }

    async function tellMeMoreOnClick() {
        const query = displaySlides[pageIndex].title + " " + displaySlides[pageIndex].data + " Tell me more";
        const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
        /*global uuid*/
        const guid = uuid.v5(query, NAMESPACE_URL);

        if (query !== '') {
            document.getElementById('spinner-overlay').style.display = 'flex';
            const encodedQuery = encodeURIComponent(query);

            const itemExists = await checkItemExists(guid);
            if (itemExists) {
                navigate(`/?item=${guid}&last=${props.guid}&index=${pageIndex}`, { replace: true });
                window.location.reload();
            } else {
                await tellMeMore(encodedQuery, props.guid, pageIndex, document.getElementById('loading'), document.getElementById('spinner-overlay'), navigate);
            }
        }
    }

    async function editItem() {
        try {
            let myResponse = {}
            myResponse[displaySlides[pageIndex].key] = document.getElementById("input-title").value +":"+document.getElementById("input-data").value
            const response = await fetch(`https://sixhats-backend.onrender.com/api/item/${props.guid}`, {
                method: "PUT",
                body: JSON.stringify({
                    expert_responses: myResponse
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();

            if (responseData) {
                // Use responseData.guid instead of guid
                console.log(responseData)
                // Todo keep your page
                window.location.reload()
            } else {
                console.log('No data returned. Try again...')
            }
        } catch (error) {
            console.error('Put error:', error.message);
        }
    }

    
    return (
        <>
            <div className="reveal" id="response-slides" {...swipeHandlers} onClick={handleTap} onMouseDown={recordMouseX}>
                {displaySlides ?
                    showAllPages ? (
                        <>
                            <div className="all-pages">
                                {displaySlides.map((content, index) => {
                                    return <div className={"slide-content page-thumbnail" + ((pageIndex == index) ? " active-page" : "")}
                                        key={index}
                                        onClick={() => handlePageClick(index)}>
                                        <h2 className="page-thumbnail-text">{getShortenedHeader(content.title)}</h2>
                                    </div>
                                })}
                            </div>
                            {/* Padding div, lets the user scroll down */}
                            <div style={{ height: "30vh" }} />
                        </>
                    ) : (
                        <>
                            <div className="page">
                                <div style={{ marginTop: "55px", marginBottom: "auto", width: "100%" }} className={displaySlides[pageIndex].edit ? "edited-response" : ""}>
                                    <h2 className="page-header-text">{displaySlides[pageIndex].title + " "}
                                        {displaySlides[pageIndex].edit ?
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderTooltip("This response has been edited by an expert")}
                                            >
                                                <FontAwesomeIcon icon={faHatWizard} style={{ color: " #6c7416" }} />
                                            </OverlayTrigger>
                                            : null}
                                    </h2>
                                {props.hasImages && pageIndex == 0?
                                        <img src="test-images/img1.png" className="slide-image"/>
                                        :null
                                }
                                {props.hasImages && pageIndex == 1?
                                        <img src="test-images/img2.png" className="slide-image"/>
                                        :null
                                }
                                {props.hasImages && pageIndex == 3?
                                        <img src="test-images/img3.png" className="slide-image"/>
                                        :null
                                }
                                    <div style={{ height: "20px" }} />
                                    <p className="page-content-text" dangerouslySetInnerHTML={{ __html: displaySlides[pageIndex].data }}></p>
                                </div>
                            </div>
                            {/* Slide controls */}
                            {pageIndex > 0 ?
                                <FontAwesomeIcon size="xl" className={"left-arrow hide-on-mobile " + (props.useExtraControls && !(lastGuid) ? "raised " : "") + (props.useExtraControls ? "left-arrow-shifted" : "")} icon={faChevronLeft} onClick={(event) => {
                                    event.stopPropagation();
                                    goToPreviousPage()
                                }} /> : null}
                            {pageIndex < slideNumber - 1 ?
                                <FontAwesomeIcon size="xl" className={"right-arrow hide-on-mobile " + (props.useExtraControls && !(lastGuid) ? "raised" : "")} icon={faChevronRight} onClick={(event) => {
                                    event.stopPropagation();
                                    goToNextPage()
                                }} /> : null}
                            {props.useExtraControls && !(lastGuid) && pageIndex > 0 ?
                                <FontAwesomeIcon size="xl" className="down-arrow" icon={faChevronDown} onClick={(event) => {
                                    event.stopPropagation();
                                    tellMeMoreOnClick()
                                }} /> : null
                            }
                            {props.useExtraControls && lastGuid ?
                                <FontAwesomeIcon size="xl" className="up-arrow" icon={faChevronUp} onClick={(event) => {
                                    event.stopPropagation();
                                    navigate(`/?item=${lastGuid}&index=${lastIndex}`, { replace: true });
                                    window.location.reload();
                                }} /> : null
                            }
                        </>
                    )
                    : null}
            </div>
            {props.allowInstant ?
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Generate a list of further queries from the current content")}
                >
                    < button className="fixed-button upper-button-3" id="btn-dig-deeper" onClick={() => { navigate("/more?title=" + displaySlides[pageIndex].title.replace(/\*/g, '').trim() + "&keywords=" + displaySlides[pageIndex].data + "&last=" + props.guid + "&index=" + pageIndex) }}>
                        <FontAwesomeIcon icon={faEllipsis} />
                    </button >
                </OverlayTrigger> : null
            }
            {props.streamGuid && props.isProUser && props.isStreamCreator ?
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Edit this response")}
                >
                    < button className="fixed-button upper-button-4" id="btn-edit" onClick={() => { setshowModal(true) }}>
                        <FontAwesomeIcon icon={faPencil} />
                    </button >
                </OverlayTrigger> : null
            }


            {/* Page numbers */}
            {!showAllPages ? (
                <div className="page-number"><h5>{(pageIndex + 1) + "/" + slideNumber}</h5></div>) : null}

            {displaySlides ?
                <Modal show={showModal} onHide={() => setshowModal(false)}>
                    {/* Modal for creating new streams */}
                    <Modal.Header closeButton>
                        <Modal.Title style={{ width: "100%", textAlign: "center" }}>Edit Response</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='stream-modal'>
                        <Form.Label className="modal-field" htmlFor="input-stream-name"><h6>Response Title</h6></Form.Label>
                        <Form.Control
                            className="modal-field"
                            type="text"
                            id="input-title"
                            defaultValue={displaySlides[pageIndex].title}
                            placeholder={displaySlides[pageIndex].title}
                        />
                        <br />
                        <h6 className="modal-field" style={{ width: "100%", textAlign: "center" }}>Response Content</h6>

                        <div style={{
                            marginTop: "10px",
                            overflow: "hidden",
                            transformOrigin: "top",
                            transition: "transform 0.26s ease"
                        }}>
                            <textarea id="input-data" defaultValue={displaySlides[pageIndex].data} placeholder={displaySlides[pageIndex].data} className="stream-table-center" style={{ padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "6px", width: "100%" }}  rows="5"/>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={editItem} variant="primary">Create</Button>
                    </Modal.Footer>
                </Modal> : null
            }
        </>
    );
}